/**
 * Tiny pub/sub used to notify interested modules (e.g. ChatSocket) when the
 * access token changes or when the user logs out.
 *
 * Kept dependency-free on purpose so it can be imported from anywhere without
 * creating circular imports.
 */

const tokenListeners = new Set();
const logoutListeners = new Set();

/** Subscribe to new access tokens. Returns an unsubscribe function. */
export const onTokenRefreshed = (fn) => {
  if (typeof fn !== 'function') return () => {};
  tokenListeners.add(fn);
  return () => tokenListeners.delete(fn);
};

/** Notify subscribers that a new access token is available. */
export const emitTokenRefreshed = (token) => {
  tokenListeners.forEach((fn) => {
    try {
      fn(token);
    } catch (e) {
      // a failing listener must never break the caller
    }
  });
};

/** Subscribe to logout events. Returns an unsubscribe function. */
export const onLoggedOut = (fn) => {
  if (typeof fn !== 'function') return () => {};
  logoutListeners.add(fn);
  return () => logoutListeners.delete(fn);
};

/** Notify subscribers that the user session ended. */
export const emitLoggedOut = () => {
  logoutListeners.forEach((fn) => {
    try {
      fn();
    } catch (e) {
      // ignore
    }
  });
};
